import axios from 'axios';
import AxiosInstance from '../config/AxiosInstance';


const createLocations = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/location', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const getLocations = async (userId: any, companyId: any, page: any, limit: any, searchValue: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/location', {
            params: {
                user_id: userId,
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};
const getListSalePointCheckList = async (companyId: string, page: string, limit: number, searchValue: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/sale-points/list`, {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailLocations = async (payload: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/location/' + payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const updateLocations = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/location/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const deleteLocations = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/location/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
};

export {
    createLocations,
    getLocations,
    deleteLocations,
    getDetailLocations,
    updateLocations,
    getListSalePointCheckList
}